import { CommitteeRoleEnum, CommitteeTypeEnum } from "../models/Committee";
import { RequestStatus, RequestType, Request } from "../models/Request";

/**
 * Predefined commitee roles for croatian teacher (CodeBook)
 * @returns {boolean} - true if roleID is croatian teacher
 */
export function isCroatianTeacherRole(roleID?: CommitteeRoleEnum): any {
  return [
    3, // Legacy check for Croatian teacher
    CommitteeRoleEnum.CroatianLanguageTeacher,
    CommitteeRoleEnum.CroatianLanguageTeacherAssigned,
  ].includes(roleID || 0);
}
/**
 * Check if CommitteeDecision could be edited
 * @returns {boolean} - true if could be edited
 */
export function canEditCommitteeDecision(
  request: Request,
  committeeType?: CommitteeTypeEnum
) {
  //check request status
  if (!committeeType || !request) return false;

  if (
    [
      CommitteeTypeEnum.Institution,
      CommitteeTypeEnum.InstitutionAssigned,
    ].includes(committeeType) &&
    request.statusId === RequestStatus.Submitted &&
    request.type !== RequestType.TemporaryExemption
  )
    return true;

  if (
    committeeType === CommitteeTypeEnum.County &&
    (request.statusId === RequestStatus.Submitted ||
      request.statusId === RequestStatus.OpinionWithRecommendation ||
      (request.statusId === RequestStatus.ProcedureSubmitted &&
        (request.type === RequestType.EarlyEnrollment ||
          request.type === RequestType.TemporaryExemption)))
  )
    return true;

  return false;
}
